<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 13/12/2021
  -->

<template>
	<div class="line-type-item-view-root mb-4">

		<div class="mb-2 card p-2" @click="onItemClicked" :class="{'line-type-selected': lineTypeItem.isSelected && !isViewOnly, 'pointer': !isViewOnly, 'hover': !isViewOnly}">
			<div v-if="showTitleInline">
				<div class="mb-2">
					<img :src="require(`../../assets/images/line-${getLineTypeFullComputed}.png`)" :alt="lineTypeItem.title" width="120" height="34" style="width: 100%; object-fit: contain;"/> <!--width and height are needed for SEO-->
				</div>
				<div class="text-center bold font-size-3">{{ titlePrefix }} {{ lineTypeItem.title }}</div>
			</div>
			<ToolTipView v-else>
				<template #icon>
					<div>
						<img :src="require(`../../assets/images/line-${getLineTypeFullComputed}.png`)" :alt="lineTypeItem.title" width="120" height="34" style="width: 100%; object-fit: contain;"/> <!--width and height are needed for SEO-->
					</div>
				</template>
                <div>{{ titlePrefix }} {{ lineTypeItem.title }}</div>
			</ToolTipView>
		</div>
	</div>

</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {LineTypeItem} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/cyeditor-edit-elements/LineTypeItem";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

export default {
	name: "LineTypeItemView",
	components: {ToolTipView},
	extends: BaseComponent,

	props: {
		lineTypeItem: {LineTypeItem, required: true},
        titlePrefix: null,
		showTitleInline: {Boolean, default: true},
        isViewOnly: Boolean
	},

	watch: {
		lineTypeItem: {
			handler(val) {
				console.log("lineTypeItem watch: ", this.lineTypeItem)
				this.isItemSelected = this.lineTypeItem.isSelected
			},
			deep: true
		}
	},

	data() {
		return {
			isItemSelected: false
		}
	},

	methods: {
		onItemClicked() {
			this.$emit('click', this.lineTypeItem)
			// this.$forceUpdate()
		}
	},

	computed: {
		getLineTypeFullComputed() {
			return this.lineTypeItem.getLineTypeFull()
		}
	},
}
</script>

<style lang="scss">
.line-type-item-view-root {
	.line-type-selected {
		border: 3px solid #00aff0;
	}

}
</style>
